import React, { useState, useEffect } from "react";
import {
  Popconfirm,
  Modal,
  Button,
  Table,
  Form,
  Input,
  message,
  Switch,
  Checkbox
} from "antd";
import axios from "axios";
import DefaultLayout from "../components/DefaultLayout";
import CloseButton from "../components/CloseButton";
import Swal from "sweetalert2";
import config from "../config";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

const ServiceSetting = () => {
  const apiBaseUrl = config.REACT_APP_API_BASE_URL;

  const [serviceData, setServiceData] = useState([]);
  const [popupModal, setPopupModal] = useState(false);
  const [editService, setEditService] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const getAllService = async () => {
    try {
      const { data } = await axios.get(
        `${apiBaseUrl}/api/services/get-services`
      );

      setServiceData(data);

      console.log(data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getAllService();
  }, []);

  //handle delete
  const handleDelete = async (record) => {
    try {
      await axios.post(`${apiBaseUrl}/api/services/delete-services`, {
        servicesId: record._id,
      });
      Swal.fire({
        title: "Success",
        text: "Service Deleted Successfully",
        toast: true,
        icon: "success",
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      getAllService();
      setPopupModal(false);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };

  const columns = [
    {
      title: "No",
      key: "index",
      render: (text, record, recordIndex) => (
        <span>{(pagination.current - 1) * pagination.pageSize + recordIndex + 1}</span>
      ),
    },
    { title: "Service Name", dataIndex: "name", sorter: (a, b) => a.name.localeCompare(b.name), showSorterTooltip: false },
    { title: "Service Price", dataIndex: "price", sorter: (a, b) => parseFloat(a.price) - parseFloat(b.price), showSorterTooltip: false },
    {
      title: "Valid for Take Away",
      dataIndex: "for_take_away",
      render: (text) => (text ? "Yes" : "No"),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Checkbox.Group
            style={{ display: 'flex', flexDirection: 'column' }}
            options={[
              { label: 'Yes', value: true },
              { label: 'No', value: false },
            ]}
            value={selectedKeys}
            onChange={(keys) => {
              setSelectedKeys(keys);
              confirm({ closeDropdown: false });
            }}
          />
          <Button
            onClick={() => {
              clearFilters();
              confirm();
            }}
            size="small"
            style={{ width: '100%', marginTop: 8 }}
          >
            Reset
          </Button>
        </div>
      ),
      onFilter: (value, record) => record.for_take_away === value,
      showSorterTooltip: false
    },
    { title: "Description", dataIndex: "description", sorter: (a, b) => (a.description || '').localeCompare(b.description || ''), showSorterTooltip: false },

    {
      title: "Actions",
      dataIndex: "_id",
      render: (id, record) => (
        <div className="action-icons">
          <EditOutlined
            style={{
              cursor: "pointer", fontSize: 22
            }}
            onClick={() => {
              setEditService(record);
              setPopupModal(true);
            }}
          />
          <Popconfirm
            title="Are you sure you want to delete this record?"
            onConfirm={() => handleDelete(record)}
            okText="Yes"
            cancelText="No"
          >
            <DeleteOutlined style={{ cursor: "pointer",fontSize: 22, marginLeft: 8 }} />
          </Popconfirm>
        </div>
      ),
    },
  ];

  const handleCancel = () => {
    if (loading) {
      return;
    }

    setPopupModal(false);
    setEditService(null);
  };

  //handle submit
  const handleSubmit = async (value) => {
    setLoading(true);
    if (editService === null) {
      try {
        const newValues = { ...value };
        const res = await axios.post(
          `${apiBaseUrl}/api/services/add-services`,
          newValues
        );
        Swal.fire({
          title: "Success",
          text: "Service Added Successfully",
          toast: true,
          icon: "success",
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        getAllService();
        setPopupModal(false);
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Something Went Wrong",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      } finally {
        setLoading(false);
      }
    } else {
      try {
        await axios.put(`${apiBaseUrl}/api/services/edit-services`, {
          ...value,
          servicesId: editService._id,
        });
        Swal.fire({
          title: "Success",
          text: "Service Updated Successfully",
          toast: true,
          icon: "success",
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        getAllService();
        setPopupModal(false);
      } catch (error) {
        message.error("Something Went Wrong");
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <DefaultLayout showSearch={false}>
      <div className="page-header">
        <h1 className="page-title">Service</h1>
        <Button type="primary" onClick={() => setPopupModal(true)}>
          Add Service
        </Button>
      </div>

      {/* <div className="d-flex justify-content-between">
        <h1>Service</h1>
        <Button type="primary" onClick={() => setPopupModal(true)}>
          Add Service
        </Button>
      </div> */}

      <Table columns={columns} dataSource={serviceData} bordered 
        //add pagination
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          pageSizeOptions: ['10', '20', '50', '100'],
          showSizeChanger: serviceData.length > 10,
          showTotal: (total, range) => `Showing ${range[0]}–${range[1]} of ${total} items`,
          onChange: (page, pageSize) => setPagination({ current: page, pageSize }),
        }} 

      />

      {popupModal && (
        <Modal
          title={
            <div>
              {editService !== null ? "Edit Service" : "Add New Service"}
              <CloseButton onClick={handleCancel} />
            </div>
          }
          open={popupModal}
          onCancel={handleCancel}
          footer={false}
        >
          <Form
            layout="vertical"
            initialValues={editService}
            onFinish={handleSubmit}
          >
            <Form.Item
              name="name"
              label="Service Name"
              rules={[
                { required: true, message: "Please input the service name!" },
                {
                  min: 3,
                  message: "Service name must be at least 3 characters long!",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="price"
              label="Service Price"
              rules={[
                { required: true, message: "Please input the service price!" },
                {
                  validator: (_, value) => {
                    const num = parseFloat(value);
                    if (!num || num === undefined || num === null || num === "") {
                      return Promise.resolve(); // Let the 'required' rule handle empty values
                    }
                    if (num < 0) {
                      return Promise.reject("Service price must be at least 0!");
                    }
                    if (num > 99999) {
                      return Promise.reject("Service price must not exceed 99999!");
                    }
                    return Promise.resolve();
                    
                  },
                },
              ]}
            >
              <Input type="number" />
            </Form.Item>

            <Form.Item
              name="for_take_away"
              label="Valid for Take Away"
              valuePropName="checked"
              initialValue={false}
            >
              <Switch />
            </Form.Item>

            <Form.Item name="description" label="Description">
              <Input />
            </Form.Item>

            <div className="d-flex justify-content-end ant-modal-footer">
              <Button
                type="primary"
                htmlType="submit"
                loading={loading} // Show loading spinner
                iconPosition="start" // Ensure the icon is positioned at the start
                disabled={loading} // Disable the button while loading
              >
                Save
              </Button>
            </div>
          </Form>
        </Modal>
      )}
    </DefaultLayout>
  );
};

export default ServiceSetting;
